// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__fU377","primary":"style_primary__omnej","primary-new":"style_primary-new__W2Zqq","primaryNew":"style_primary-new__W2Zqq","block":"style_block__J6dId"};